module.exports = __webpack_public_path__ + "img/pma560_new_terminals_banner.46cb1d20.jpg";